<template>
    <div>
        <el-dialog v-el-drag-dialog :visible.sync='isShow' title='宿舍列表' width='1000px' :close-on-click-modal='false'
            :before-close="handleClose" destroy-on-close append-to-body>
            <div style="padding-bottom: 10px;display: flex;gap: 8px;">
                <el-select v-model="selectedFloorId" placeholder="请选择" @change="loadListData">
                    <el-option v-for="item in floorOption" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
                <div style="display: flex;align-items: center;">
                    <div style="width: 54px;">宿舍名：</div>
                    <div><el-input v-model="dormName" @change="loadListData" placeholder="请输入宿舍名" /></div>
                </div>
            </div>
            <el-table :data="pageInfo.list" style="width: 100%;border-bottom: 1px solid #dee2e6;" max-height="250" border v-loading="loading">
                <el-table-column label="序号" type="index" width="50" align="center"></el-table-column>
                <el-table-column label="宿舍名" prop="dormName" align="left"></el-table-column>
                <el-table-column label="入住性别" align="center" width="100">
                    <template slot-scope="scope">
                        {{ scope.row.checkInGender == '0' ? '男' : '女' }}
                    </template>
                </el-table-column>
                <el-table-column label="所在宿舍楼" width="140" prop="floorName" align="center"></el-table-column>
                <el-table-column label="总床位" width="120" prop="totalBedNum" align="center"></el-table-column>
                <el-table-column label="可分配床位" width="140" prop="notBedNum" align="center" sortable></el-table-column>
                <el-table-column label="分配床位" align="center" width="100">
                    <template slot-scope="scope">
                        <el-input-number v-model="scope.row.bedNum" @change="handleInputChange(scope.row)" :min="0"
                            :max="scope.row.notBedNum" style="width: 80px;" size="mini"></el-input-number>
                    </template>
                </el-table-column>
            </el-table>
            <div style="display: flex;gap: 8px;margin-top: 10px;">
                <el-tag v-for="dorm in curRows" :key="dorm.id" closable type="success"
                    @close="() => { removeSelectedMap(dorm.id) }">
                    {{ `${dorm.dormName}(${dorm.bedNum}个)` }}
                </el-tag>
            </div>
            <div v-if="pageInfo.total > 0" class="el-pagination-container">
                <el-pagination :current-page="pageInfo.pageNum" :page-sizes="pageSizes" :page-size="pageInfo.pageSize"
                    :total="pageInfo.total" :hide-on-single-page="false"
                    layout="total, sizes, prev, pager, next, jumper" prev-text="上一页" next-text="下一页"
                    @size-change="handlePageSizeChange" @current-change="handlePageNumChange" />
            </div>
            <span slot='footer' class='dialog-footer'>
                <el-button type='primary' @click='save'>保 存</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    props: {
        show: {
            type: Boolean,
            default: () => false
        },
        type: {
            type: String,
            default: () => ''
            // 0：男
            // 1：女
        },
        vo: {
            type: Object,
            default: () => { }
        },
        bodyType: {
            type: Object,
            default: () => { }
        },
        selectedRows: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            pageInfo: { pageSize: 10, total: 0, pageNum: 1, list: [] },
            pageSizes: [10, 20, 50, 100],
            selectedMap: new Map(),
            floorOption: [
                {
                    value: '',
                    label: '宿舍楼'
                },
            ],
            selectedFloorId: '',
            dormName: '',
            curRows: [],
            loading: false
        }
    },
    computed: {
        isShow: {
            get() {
                return this.show
            },
            set(val) {
                this.$emit('update:show', val)
            }
        },
        mapToArray() {
            return this.selectedMap.values();
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        init() {
            this.loadFloorList()
            this.loadListData()
            this.curRows = this.selectedRows.filter(item => item.gender == this.type).map(item => {
                return {
                    ...item,
                    id: item.dormId
                }
            })
            this.curRows.forEach(item => {
                this.selectedMap.set(item.dormId, item)
            })
        },
        async loadListData() {
            const pageInfo = { ...this.pageInfo }
            pageInfo.urlsearch = `notBedNum>0;checkInGender:${this.type};status=1`
            if (this.selectedFloorId) {
                pageInfo.urlsearch += `;floorId:${this.selectedFloorId}`
            }
            if (this.dormName) {
                pageInfo.urlsearch += `;dormName like ${this.dormName}`
            }
            this.loading = true
            try {
                const { body, message, code } = await this.$app.listdata('xsgl/dormConfig/listdata', pageInfo)
                if (code == 'success') {
                    body.pageInfo.list.forEach(item => {
                        const find = this.selectedMap.get(item.id)
                        if (find) {
                            item.bedNum = find.bedNum
                        } else {
                            item.bedNum = 0
                        }
                    })
                    this.pageInfo = body.pageInfo
                } else {
                    this.$message.error(message)
                }
            } finally {
                this.loading = false
            }
        },
        handlePageSizeChange(val) {
            this.pageInfo.pageNum = 1
            this.pageInfo.pageSize = val
            this.loadListData()
        },
        handlePageNumChange(val) {
            this.pageInfo.pageNum = val
            this.loadListData()
        },
        handleInputChange(row) {
            if (row.bedNum > 0) {
                this.selectedMap.set(row.id, row)
            } else {
                this.selectedMap.delete(row.id)
            }
            this.curRows = [...this.selectedMap.values()]
        },
        save() {
            let list = JSON.parse(JSON.stringify([...this.selectedMap.values()]))
            const vo = this.vo
            list = list.map(item => {
                return {
                    ...this.bodyType,
                    bedNum: item.bedNum,
                    dormId: item.id,
                    dormName: item.dormName,
                    floorName: item.floorName,
                    gender: item.checkInGender,
                    totalBedNum: item.totalBedNum,
                    className: vo.className,
                    classId: vo.classId,
                    teacherId: vo.teacherId,
                    teacherName: vo.teacherName,
                    schoolYear: vo.schoolYear,
                    facultyName: vo.facultyName,
                    facultyId: vo.facultyId,
                    majorSubcategory: vo.majorSubcategory,
                    majorSubcategoryId: vo.majorSubcategoryId,
                }
            })
            this.$emit('check', list)
            this.isShow = false
        },
        async loadFloorList() {
            const pageInfo = { pageSize: 9999, total: 0, pageNum: 1 }
            pageInfo.urlsearch = `checkInGender:${this.type};status=1`
            const { body, message, code } = await this.$app.listdata('xsgl/dormFloor/listdata', pageInfo)
            if (code == 'success') {
                this.floorOption.push(...body.pageInfo.list.filter(item => item.floorName).map(item => {
                    return { label: item.floorName, value: item.id }
                }))
            } else {
                this.$message.error(message)
            }
        },
        removeSelectedMap(key) {
            this.selectedMap.delete(key)
            const find = this.pageInfo.list.find(item => item.id == key)
            if (find) {
                find.bedNum = 0
            }
            this.curRows = [...this.selectedMap.values()]
        },
        handleClose(done) {
            
            this.$confirm('分配床位未保存，确认关闭？')
                .then(_ => {
                    done();
                })
                .catch(_ => { });
        }

    }

}
</script>

<style lang='scss' scoped>
.el-pagination-container {
    text-align: right;
    margin-top: 10px;
}
</style>